import { isDeletionCooldownError } from './authError.js';

/**
 * 구글 OAuth 연동 보조 유틸리티
 */

/**
 * i18n 현재 언어 코드를 구글 OAuth hl 파라미터 형식으로 정규화
 * 
 * - 구글 OAuth는 BCP 47 언어 태그를 지원 (예: ko, en, ja, vi, zh-CN, zh-TW 등).
 * - 언어-지역(ko-KR, en-US 등)은 2~3자리 베이스 언어로 정규화.
 * - 중국어는 zh-CN(간체), zh-TW(번체)로 변환.
 * - 비정상값 또는 빈 값은 null 반환 (queryParams 생략 처리용).
 */
export function normalizeGoogleHl(rawLang) {
  if (!rawLang || typeof rawLang !== 'string') return null;
  const clean = rawLang.trim().toLowerCase().replace('_', '-');
  if (!clean) return null;

  // 중국어 간체/번체
  if (clean === 'zh-cn' || clean === 'zh-hans') return 'zh-CN';
  if (clean === 'zh-tw' || clean === 'zh-hant' || clean === 'zh-hk') return 'zh-TW';

  // 베이스 언어 코드 (예: ko-kr -> ko, en-us -> en)
  const base = clean.split('-')[0];
  if (/^[a-z]{2,3}$/.test(base)) {
    return base;
  }
  return null;
}

/**
 * URL(query 또는 hash)에서 OAuth 에러 파라미터 감지 및 취소 여부 판별
 */
export function detectOAuthError(searchStr = window.location.search, hashStr = window.location.hash) {
  try {
    const searchParams = new URLSearchParams(searchStr || '');
    const cleanHash = (hashStr || '').startsWith('#') ? hashStr.substring(1) : (hashStr || '');
    const hashParams = new URLSearchParams(cleanHash);

    const error = searchParams.get('error') || hashParams.get('error');
    const errorCode = searchParams.get('error_code') || hashParams.get('error_code');
    const errorDesc = searchParams.get('error_description') || hashParams.get('error_description') || '';

    if (!error && !errorCode && !errorDesc) return null;

    // 1. 차단(쿨다운) 여부 우선 판별 (403 코드 또는 훅 에러가 취소로 오인되는 것 방지)
    const isCooldown = isDeletionCooldownError(errorDesc) || isDeletionCooldownError(error);

    // 2. 차단이 아닌 경우에만 취소 여부 판별
    const isCancelled =
      !isCooldown &&
      (error === 'access_denied' ||
        errorCode === '403' ||
        errorDesc.toLowerCase().includes('declined') ||
        errorDesc.toLowerCase().includes('denied') ||
        errorDesc.toLowerCase().includes('cancel') ||
        errorDesc.toLowerCase().includes('closed'));

    return {
      error,
      errorCode,
      errorDesc,
      isCancelled,
      isCooldown,
    };
  } catch {
    return null;
  }
}

